import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-screen-2xl mx-auto px-4 md:px-10" }
const _hoisted_2 = { class: "bg-white rounded-xl px-8 md:px-16 py-12 font-light" }

import { useI18n } from "vue-i18n";
import BaseHeadline from "@/components/baseHeadline.vue";
import DiamondDetailCaratContent from "@/components/diamonds/details/DiamondDetailCaratContent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondDetailCarat',
  props: {
    carat: {},
    form: {},
    width: {},
    length: {}
  },
  setup(__props: any) {

const { t } = useI18n();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DiamondDetailCaratContent, {
        carat: __props.carat,
        form: __props.form,
        width: __props.width,
        length: __props.length
      }, {
        title: _withCtx(() => [
          _createVNode(BaseHeadline, { class: "!text-2xl mb-6 !normal-case !tracking-normal" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("components.diamonds.details.carat.title")) + ": " + _toDisplayString(_ctx.$n(__props.carat)) + " ct. ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["carat", "form", "width", "length"])
    ])
  ]))
}
}

})